module.exports = __webpack_public_path__ + "img/trainline_accredited.751ed457.png";